import createElement from '../logical-components/createElement';
import svgs from '../visual-components/svgs';
// import imageServiceUrlBuilder from '../core/utils/imageServiceUrl'
var generateProfileImage = function (data) {
    var _a, _b;
    var DOM = createElement('div');
    var hasImage = ((_a = data === null || data === void 0 ? void 0 : data.avatar) === null || _a === void 0 ? void 0 : _a.url_thumbnail) || ((_b = data === null || data === void 0 ? void 0 : data.avatar) === null || _b === void 0 ? void 0 : _b.url);
    var image = hasImage
        ? "<img src='".concat(hasImage, "' alt='").concat(data.name, "' />")
        : svgs.mensenlinq;
    DOM.innerHTML = "\n        <div class='_mnslq-card-image'>\n            ".concat(image, "\n        </div>\n    ");
    return DOM.innerHTML;
};
export default generateProfileImage;
